import { useQuery } from '@tanstack/react-query';

import {
  helpscoutInfoQueryOptions,
  useDeleteHelpscoutMutation,
  useImportHelpscoutFeedbackMutation,
  useUpdateHelpscoutMailboxesMutation,
} from '@/entities/(integration)/helpscout';
import useWorkspaceStore from '@/stores/WorkspaceStore';

export const useHelpScout = (enabled: boolean) => {
  const currWorkspace = useWorkspaceStore((state) => state.currWorkspace);
  const workspaceAlias = currWorkspace?.alias;
  if (!workspaceAlias) throw new Error('Workspace alias is required');

  const { data: helpscoutWorkspace } = useQuery(
    helpscoutInfoQueryOptions(workspaceAlias, { enabled }),
  );

  const deleteMutation = useDeleteHelpscoutMutation(workspaceAlias);
  const importMutation = useImportHelpscoutFeedbackMutation(workspaceAlias);
  const updateMailboxesMutation =
    useUpdateHelpscoutMailboxesMutation(workspaceAlias);

  return {
    helpscoutWorkspace,
    deleteMutation,
    importMutation,
    updateMailboxesMutation,
  };
};
